import { render, staticRenderFns } from "./DefaultPage.vue?vue&type=template&id=e41e73a8&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Kommunetorget\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e41e73a8')) {
      api.createRecord('e41e73a8', component.options)
    } else {
      api.reload('e41e73a8', component.options)
    }
    module.hot.accept("./DefaultPage.vue?vue&type=template&id=e41e73a8&", function () {
      api.rerender('e41e73a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/DefaultPage.vue"
export default component.exports